import { SettingFilled } from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
import { CardSelection } from 'components/pages/communication-hub/components';

export const QuestionGenerationStep = ({ questionGeneration, handleValue }) => {
  const options = [
    {
      value: 'ai',
      Icon: SettingFilled,
      label: 'AI-Generated Questions',
      description: 'Let AI create customized questions based on your audit type and specific objectives',
      color: 'purple',
    },
    {
      value: 'standard',
      Icon: SettingFilled,
      label: 'Standard Question Set',
      description: 'Choose from pre-built question templates designed for each audit type',
      color: 'blue',
    },
  ];

  return (
    <div>
      <Typography.Title level={5}>Question Generation</Typography.Title>
      <Typography.Paragraph>Choose how you'd like to create questions for your audit</Typography.Paragraph>
      <Row gutter={[16, 16]}>
        {options.map((item) => (
          <Col key={item.value} span={12}>
            <CardSelection
              onClick={() => handleValue('questionGeneration', item.value)}
              style={
                questionGeneration === item.value
                  ? { border: '1px solid #00506c', background: '#f9fdff', color: '#00506c' }
                  : {}
              }
              color={item.color}
              Icon={item.Icon}
              label={item.label}
              description={item.description}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};
